import { useLayoutEffect } from 'react';
import {useSearchParams} from 'react-router-dom';

import useCookie from './useCookie';

const TENANT_ID_KEY = 'tenantId';

const getParentDomain = () => {
  const parts = window.location.hostname.split('.');

  if (parts.length === 3) {
    return `.${parts[1]}.${parts[2]}`;
  }

  return undefined;
};
export const useTenantId = (): string | null => {
  const [searchParams] = useSearchParams();
  const paramTenantId = searchParams.get(TENANT_ID_KEY);
  const [cookieValue, updateCookie] = useCookie(TENANT_ID_KEY);

  useLayoutEffect(() => {
    if (paramTenantId) {
      updateCookie(paramTenantId, { domain: getParentDomain(), path: '/', secure: true, sameSite: 'lax', expires: 400 });
    }
  }, [paramTenantId, updateCookie]);

  return cookieValue;
};
